<!-- <main class="flex-shrink-0">
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="card">
          <nav>
            <div id="nav-tab" role="tablist">
              <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
                <li [ngbNavItem]="link.route" *ngFor="let link of links">
                  <a ngbNavLink routerLink="{{ link.route }}" routerLinkActive="active" i18n="@@LinkTitle">
                    <app-svg [source]="'icons/feather/' + link.icon" height="18"></app-svg>
                    <span>{{ link.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <div class="card">
            <div class="card-body">
              <div class="tab-content mt-2" id="nav-tabContent">
                <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
              </div>
            </div>
          </div>

          <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
            <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</main> -->

<main id="manage">
  <div class="card">
    <nav>
      <div id="nav-tab" role="tablist">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
          <li [ngbNavItem]="link.route" *ngFor="let link of links" domId="tab_{{ link.route }}">
            <a ngbNavLink routerLink="{{ link.route }}" routerLinkActive="active" i18n="@@LinkTitle">
              <app-svg [source]="'icons/feather/' + link.icon" height="18"></app-svg>
              <span>{{ link.title }}</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="card">
      <div class="card-body">
        <div class="tab-content mt-2" id="nav-tabContent">
          <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
        </div>
      </div>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
      <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
    </div>
  </div>
</main>

<ng-template #defaultFooter>
  <div class="d-flex">
    <div class="flex-fill d-none d-md-inline">
      <div class="d-flex">
        <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
        <div class="flex">
          <select id="pageSize"
                  name="pageSize"
                  [(ngModel)]="tableFunctions.pageSize"
                  class="form-control form-select custom-select"
                  aria-label=""
                  (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
            <option [ngValue]="250">250</option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
      <ngb-pagination #pagination
                      [collectionSize]="(tableFunctions.total$ | async)!"
                      [(page)]="tableFunctions.page"
                      [pageSize]="tableFunctions.pageSize"
                      [maxSize]="tableFunctions.page == 4 ? 4 : 3"
                      [boundaryLinks]="true"
                      [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="flex-fill justify-content-end d-none d-md-inline">
      <div class="d-flex float-end">
        <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
        <div class="flex">
          <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
            <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--<router-outlet></router-outlet>-->
